module.exports = __webpack_public_path__ + "media/theme/apple-touch-icon-93274eda.png";